import { Controller } from "@hotwired/stimulus"

const HEIGHT_MESSAGE_TYPE = "ninembc:embed:calendar:height"

export default class extends Controller {
  connect() {
    this.postHeight = this.postHeight.bind(this)
    this.schedulePostHeight = this.schedulePostHeight.bind(this)

    this.resizeObserver = new ResizeObserver(this.schedulePostHeight)
    this.resizeObserver.observe(document.documentElement)

    window.addEventListener("resize", this.schedulePostHeight)
    window.addEventListener("load", this.schedulePostHeight)
    window.addEventListener("embed:content-resized", this.schedulePostHeight)
    document.addEventListener("turbo:load", this.schedulePostHeight)

    this.schedulePostHeight()
  }

  disconnect() {
    this.resizeObserver?.disconnect()

    window.removeEventListener("resize", this.schedulePostHeight)
    window.removeEventListener("load", this.schedulePostHeight)
    window.removeEventListener("embed:content-resized", this.schedulePostHeight)
    document.removeEventListener("turbo:load", this.schedulePostHeight)

    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
      this.animationFrameId = null
    }
  }

  schedulePostHeight() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
    }

    this.animationFrameId = requestAnimationFrame(this.postHeight)
  }

  postHeight() {
    this.animationFrameId = null

    if (window.parent === window) return

    const height = Math.max(
      document.body?.scrollHeight || 0,
      document.body?.offsetHeight || 0,
      document.documentElement?.clientHeight || 0,
      document.documentElement?.scrollHeight || 0,
      document.documentElement?.offsetHeight || 0
    )

    if (!height || height === this.lastHeight) return

    this.lastHeight = height
    window.parent.postMessage({ type: HEIGHT_MESSAGE_TYPE, height }, "*")
  }
}
